import { Trophy } from 'lucide-react'

export function TopProductsbyBranch({ branches, topProductsByBranch }: { branches: any[], topProductsByBranch: any[] }) {
    return (
        <div className="rounded-lg border border-slate-200 bg-white p-6">
            <h3 className="mb-4 font-semibold text-slate-900">
                Productos Más Vendidos por Sucursal
            </h3>
            <div className="flex w-full snap-x snap-mandatory gap-6 overflow-x-auto pb-4">
                {branches.map((branch) => {
                    const branchProducts = topProductsByBranch.filter(
                        (p) => p.branch === branch.name.replace('Sucursal ', ''),
                    )
                    return (
                        <div key={branch.id} className="min-w-[280px] shrink-0 snap-center md:min-w-[320px]">
                            <h4 className="mb-3 font-medium text-slate-900">
                                {branch.name}
                            </h4>
                            <div className="space-y-3">
                                {branchProducts.map((product, idx) => (
                                    <div
                                        key={idx}
                                        className="relative flex items-center justify-between overflow-hidden rounded-xl border border-slate-100 bg-white p-4 shadow-sm transition-all hover:shadow-md"
                                    >
                                        <div className="absolute left-0 top-0 h-full w-1 bg-primary/40"></div>
                                        <div className="flex items-center gap-3">
                                            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-50 text-sm font-bold text-slate-400">
                                                {idx === 0 ? <Trophy className="h-4 w-4 text-yellow-500" /> : idx + 1}
                                            </div>
                                            <p className="max-w-[140px] truncate text-sm font-medium text-slate-700 md:max-w-[180px]" title={product.product}>
                                                {product.product}
                                            </p>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-sm font-bold text-primary">
                                                {product.units} <span className="text-xs font-normal text-slate-500">uds</span>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}